import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './Button.css';

class Button extends Component {
  static propTypes = {
    children: PropTypes.node,
    classes: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    right: PropTypes.bool,
  };

  static defaultProps = {
    children: 'Button',
    onClick: () => console.warn('Please provide a valid callback for the click event.'),
    classes: 'primary'
  };

  buttonRef = React.createRef();

  render() {
    const {
      onClick,
      children,
      icon,
      right,
      classes,
      disabled,
      ...rest
    } = this.props;
    const cx = classnames.bind(styles);
    const cssModulesClasses = classes.split(' ').map(className => styles[className] || className);

    return (
      <button
        className={cx(styles.btn, cssModulesClasses, {
          'with-icon': icon,
          'right': right,
          'disabled': disabled
        })}
        disabled={disabled}
        ref={this.buttonRef}
        onClick={onClick}
        {...rest}
      >
        { icon && !right && <Icon type={'20'} icon={icon} /> }
        {children}
        { icon && right && <Icon type={'20'} icon={icon} /> }
      </button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/uis/elements/Buttons/Button.js